import { SupplierModelType } from '@teinor/erp/types/company/supplier'
import { useState } from 'react'
import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import SingleFormLayout from '../../../../../../../../baseComponents/Layout/SingleFormLayout'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { getDictionaryStates } from '../../../../../../../../utils/globals/countries'
import { valueOrDefaultValue } from '../../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { useTypeIdNumber } from '../../../../../../../../utils/hooks/useTypeIdNumber'
import { getActiveLangs, getDictionaryCountries } from '../../../../../../../../utils/reducers/getters'
import { sortCountries } from '../../../../../../../../utils/globals/sortCountries'

type MainCreditorProfileProps = ComponentWithPermissions & {
    basicData: SupplierModelType | null
    getData: () => Promise<void>
}

const MainCreditorProfile: React.FC<MainCreditorProfileProps> = ({ basicData, userPermissions, getData }) => {
    const { t } = useTwinTranslation()
    const { country, setCountry } = useMainCreditorProfileLogic({ basicData })
    const { typesIdNumber } = useTypeIdNumber()

    const fields: FormRender<SupplierModelType> = [
        {
            cols: 2,
            title: t('generalInformation', 'Información General'),
            elements: [

                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'fiscal_name',
                    label: t('fiscalName', 'Nombre fiscal'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'type_id_number',
                    label: t('typeIdNumber', 'Tipo de documento identificación'),
                    component: 'CustomSelect',
                    items: typesIdNumber,
                    value: basicData?.type_id_number
                },
                {
                    name: 'id_number',
                    label: t('id_number', 'DNI'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'code',
                    label: t('supplierCode', 'Código de Proveedor'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                    type: 'text'
                },
            ]
        },
        {
            cols: 2,
            title: t('address', 'Dirección'),
            elements: [
                {
                    name: 'address',
                    label: t('address', 'Dirección'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'additional_address',
                    label: t('additional_address', 'Dirección adicional'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'postal_code',
                    label: t('postal_code', 'Código Postal'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'city',
                    label: t('city', 'Ciudad'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'country',
                    label: t('country', 'País'),
                    component: 'CustomSelectWithSearchBar',
                    items: getDictionaryCountries(),
                    sortFunction: sortCountries,
                    value: country,
                    onChange: (value: string) => setCountry(value),
                },
                {
                    name: 'state',
                    label: t('state', 'Provincia'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: getDictionaryStates(country),
                    value: basicData?.state,
                },
            ]
        },
        {
            cols: 2,
            title: t('contactInformation', 'Datos de contacto'),
            elements: [
                {
                    name: 'phone',
                    label: t('phone', 'Teléfono'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'mobile',
                    label: t('mobile', 'Móvil'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'email',
                    label: t('email', 'Email'),
                    component: 'InputWithLabelMargin',
                    type: 'email',
                },
                {
                    name: 'web',
                    label: t('web', 'Página web'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                },
                // {
                //     name: 'PdfTemplateId',
                //     label: t('Document type', 'Tipo de documento'),
                //     component: 'CustomSelect',
                //     items: pdfTemplates || {},
                // },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.id
                }
            ]
        }
    ]
    const parsedFields = valueOrDefaultValue(fields, userPermissions, basicData)

    return (
        <SingleFormLayout action='/api/app/supplier/updateSupplier' onSubmit={getData} sections={parsedFields} userPermissions={userPermissions} />
    )
}
interface MainCreditorProfileLogicProps {
    basicData: SupplierModelType | null
}

const useMainCreditorProfileLogic = ({ basicData }: MainCreditorProfileLogicProps) => {
    const [country, setCountry] = useState(basicData?.country || '')

    return { country, setCountry }
}

// const MainCreditorProfileDispatch = {
//     setPdfTemplates: (payload: PdfTemplatePayload) => ({ type: 'CHANGE_PDFTEMPLATE', payload }),
// }

// export type ReduxMainCreditorProfile = ConnectedProps<typeof mainCreditorProfileConnect>
// const mapMainCreditorProfileConnector = (state: AllReduxPayloads) => ({ pdfTemplates: state.pdfTemplates })
// const mainCreditorProfileConnect = connect(mapMainCreditorProfileConnector, MainCreditorProfileDispatch)
// const MainCreditorProfileLoading = withLoading(MainCreditorProfile, [{ fetchUrl: '/api/app/config/pdfTemplate/getAllPdfTemplates', propName: 'pdfTemplates', setFunctionName: 'setPdfTemplates' }])
// const MainCreditorProfileConnect = mainCreditorProfileConnect(MainCreditorProfileLoading)

export default MainCreditorProfile